import { IPromise } from 'angular';
import { call, put } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { L10n } from '../../../../ts/L10n/L10n';
import { FlowDefinition, GroupDefinition, MetricDefinition, ProjectDefinition, ScheduleDefinition, WorkbookDefinition } from '../../../../ts/models/ContentDefinitions';
import { IContentInfo } from '../../../../ts/models/IContentInfo';
import { IResult } from '../../../../ts/ServerApi/types/IResponse';
import { RenameAction } from '../../../../ts/services/RenameAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { RenameContentAction } from '../../../actions/spaces/RenameContentAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { ServiceLocator } from '../../../ServiceLocator';
import { reloadSpaceIfUpdatingCurrentSpace } from './RefreshContentSagas';

export function* handleRenameContent(action: RenameContentAction) {
  try {
    const result = yield call(openRenameDialog, action.content);

    if (result && result.errors && result.errors.length > 0) {
      const localizedErrorMessage = yield call(getLocalizedErrorMessage, action.content);
      yield put(requestFailed(result.errors[0].message, localizedErrorMessage));
    } else  {
      const maybeReloaded = yield call(reloadSpaceIfUpdatingCurrentSpace, [action.content]);
      if (!maybeReloaded) {
        yield put(requestSpaceContents());
      }
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}

export function getLocalizedErrorMessage(content: IContentInfo) {
  if (content.contentType === ProjectDefinition.contentType) {
    return Messages.projectRenameError({ PROJECT_NAME: content.name });
  } else if (content.contentType === WorkbookDefinition.contentType) {
    return Messages.workbookRenameError({ WORKBOOK_NAME: content.name });
  } else if (content.contentType === FlowDefinition.contentType) {
    return Messages.flowRenameError({ FLOW_NAME: content.name });
  } else if (content.contentType === ScheduleDefinition.itemType) {
    return Messages.scheduleRenameError({ SCHEDULE_NAME: L10n.elideIfLong(content.name) });
  } else if (content.contentType === MetricDefinition.itemType) {
    return Messages.metricRenameError({ METRIC_NAME: content.name });
  } else if (content.contentType === GroupDefinition.contentType) {
    return Messages.groupRenameError({ GROUP_NAME: content.name });
  }
  return Messages.errorUnknown();
}

export function openRenameDialog(content: IContentInfo): IPromise<IResult> {
  const renameService = ServiceLocator.get<RenameAction>('RenameAction');
  const context = ServiceLocator.getAngularActionContext();
  if (content.contentType === ProjectDefinition.contentType) {
    return renameService.renameProject(content, context);
  } else if (content.contentType === WorkbookDefinition.contentType) {
    return renameService.renameWorkbook(content, context);
  } else if (content.contentType === FlowDefinition.contentType) {
    return renameService.renameFlow(content, context);
  } else if (content.contentType === ScheduleDefinition.itemType) {
    return renameService.renameSchedule(content, context);
  } else if (content.contentType === MetricDefinition.itemType) {
    return renameService.renameMetric(content, context);
  } else if (content.contentType === GroupDefinition.contentType) {
    return renameService.renameGroup(content, context);
  }
}
